<template>
  <div id="floatingSupport">
    <div id="contactModal" class="modal z-depth-light-1 white" ref="contactModal">
      <div class="modal-content">
      <div class="contactNav" v-if="currentlyShowing === 'nav'">
        <div class="header">
        <span class="title">Need help with something?</span>
        </div>
        <div class="close-header">
          <button class="btn-floating waves modal-close effect transparent z-depth-0 btn-small grey-text text-darken-2">
            <i class="material-icons grey-text text-darken-2">close</i>
          </button>
        </div>
      </div>

      <div class="contactForm">
        <contact-form
        :submission="submission"
        :data-form="dataForm"
        :auth-user="dataUser"
          @status="$_formShow($event)"
        ></contact-form>
      </div>

      <div class="contactInfo" v-if="currentlyShowing === 'call'">
        <div class="head">
          <button  @click="$_formShow('nav')"
            class="btn-floating white z-depth-0">
            <i class="material-icons grey-text text-darken-3">arrow_back</i>
          </button>
          <div class="title">Call or Find Us</div>
         <div class="clear"></div>
        </div>
        <div class="csPage row">
        <div class="col "><a class="btn-floating white "> <i class="material-icons grey-text text-darken-3">local_phone</i> </a><p></p>
        <p><a class="btn-floating white "> <i class="material-icons grey-text text-darken-3">place</i> </a></p>
        </div>
        <div class="col">
        <ul>
        <li class="numberLi">Call Us 1.758.458.4629</li>
        <li>Third Floor, Sir Stanislaus James Building</li>
        <li>The Waterfront, Castries, Saint Lucia</li>
        </ul>
        </div>
        </div>
      </div>

   <!--    <div class="conversation"  v-if="currentlyShowing === 'conversation'">
          <div class="header-area">
          <button  @click="$_formShow('nav')"
            class="btn-floating white z-depth-0">
            <i class="material-icons grey-text text-darken-3">arrow_back</i>
          </button>
          <div class="title-area">Messages</div>
          <div class="clear"></div>
        </div>
        <comment-chat>
          
        </comment-chat>
      </div> -->

      </div>
    </div>
    <button class="btn-floating btn-large blue accent-4"  @click="$_initModal()" >
      <i class="material-icons white-text">contact_support</i>
    </button>
    <!-- <button 
    @click="$_initModal()" 
    class=" btn white grey-text text-darken-3 waves-effect white z-depth-light-1">
    <i class="material-icons left">mail</i> have questions ? </button> -->
  </div>
</template>
<script>
import contactForm from '@/components/contactForm.component'
import core from '@/functions'
export default {
  name:'appSupport',
  props:{
    submission:{
      type:[Object, Boolean],
    },
    dataForm: {
      type: String,
    },
    dataUser:{
      type:Object,
    }
  },
  data(){
    let vm  = this
    return {
      currentlyShowing:'nav',
      modalInstance:Object,
      modalOptions:{
        opacity:0,
        preventScrolling:false,
        onCloseEnd:()=>{
          vm.modalInstance.destroy()
        }
      }
    }
  },
  components: {
    contactForm
  },
  methods: {
    $_initModal () {
      this.modalInstance = core.initModal(this.$refs.contactModal, this.modalOptions)
      this.$nextTick( () => {
        this.modalInstance.open()
      }, 300)
    },
    $_formShow (e) {
     this.currentlyShowing = e
    }
  }
}
</script>
<style lang="scss" scoped>
#floatingSupport {
    position: fixed;
    right: 24px;
    z-index: 999;
    bottom: 64px;
    div#contactModal {
        right: 24px !important;
        left: inherit;
        border-radius: 8px;
        bottom: 24px;
        top: initial !important;
        max-width: 450px;
        width: 100%;
        @media screen and (max-width: 680px){
          right: 24px !important;
          left: 2%;
          max-width: 360px;
          width: 96%;
        }
        .modal-content {
          padding:0px;
        }
    }
    .close-header {
      display: inline-block;
      right: 0;
      position: absolute;
      top: 0;
      padding: 12px;
    }
    .contents {
      width: 100%;
      min-height: 300px;
        ul {
          padding: 0px;
          margin: 0;
          width: 100%;
          li {
            padding: 16px;
            width: 100%;
            border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
          }
        }
    }
    .header {
      padding: 24px 24px 16px 24px;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    }
    span {
      &.title {
        font-size: 22px;
        display: flex;
      }
      &.message {
        font-size: 16px;
        display: flex;
      }
    }
    .head {
      margin-bottom: 16px;
      button{ 
        float:left;
        margin-right:16px;
      }
      .title {
        font-size: 21px;
        float: left;
        line-height: 36px;
      }
    }
  .contactInfo {
    padding:16px;

    .csPage {
      &.row {
          margin-bottom: 0px !important;
          ul {
            margin:0px !important;
            li {
              &.numberLi {
                  font-size: 21px;
                  margin-bottom: 15px;
                  vertical-align: middle;
              }
            }
          }
      }
    }
  }
}
.conversation {
  .header-area {
    display: flex;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    padding: 16px;
    line-height: 38px;
    position: relative;
    z-index: 9;
      button {
        
      }
    .title-area {
      font-size: 19.5px;
      letter-spacing: 0.7px; 
    }
  }
 
}
</style>
<style lang="scss" >
.admin {
  #floatingSupport {
    display: none; 
    z-index: -1;
  }
}
</style>